import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import { useState } from 'react'
import { toastHelper } from '../../../util/toastHelper'

const foodTypes = [
	// 'Not sure yet',
	'Italian',
	'American',
	'Chinese',
	'Indian',
	'French',
	'Mexican',
	'African',
	'Caribbean',
	'Japanese',
]

function Food({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	const [other, setOther] = useState(false)

	const toggleSelect = (title) => {
		setOther(false)
		setWeddingData((prev) =>
			prev.foodType.includes(title)
				? {
						...weddingData,
						foodType: prev.foodType.filter((t) => t !== title), // remove if already selected
					}
				: {
						...weddingData,
						foodType: [...prev.foodType, title], // add if not selected
					}
		)
	}
	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>What kind of food are you looking to serve?</h2>
					<p style={{ marginTop: '5px' }}>Can select multiple</p>
					<div
						className=""
						style={{ width: '100%', marginTop: '15px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								{foodTypes.map((label, idx) => (
									<ButtonCustom
                                        key={idx}
										data-cy={`${label}`}
										variant="pilled"
										style={{
											backgroundColor:
												weddingData.foodType.includes(
													label
												)
													? '#7ca6bd'
													: '#FFF',
											color: weddingData.foodType.includes(
												label
											)
												? '#FFF'
												: '#7ca6bd',
										}}
										onClick={() => toggleSelect(label)}
									>
										{label}
									</ButtonCustom>
								))}
								<ButtonCustom
									variant="pilled"
									style={{
										backgroundColor: other
											? '#7ca6bd'
											: '#FFF',
										color: other ? '#FFF' : '#7ca6bd',
									}}
									onClick={() => {
										setOther(true)
										setWeddingData({
											...weddingData,
											foodType: [],
										})
									}}
								>
									Other
								</ButtonCustom>
							</div>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					data-cy="wizard-next"
					onClick={() => {
						if (!weddingData.foodType.length && !other)
							return toastHelper(
								'Please select at least one option',
								'error'
							)
						handleNext()
					}}
				>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={2.5} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default Food
